// @flow
import React from 'react';
import Avatar from '@atlaskit/avatar';
import styled from 'styled-components';

const AvatarNameView = styled.div`
    p {
        margin-left: 7px;
        margin-top: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: calc(100% - 48px);
    }
    > * {
        display: inline-block;
        vertical-align: middle;
    }
`;

type Props = {
    displayName: string,
    avatarSrc: string,
    avatarHref?: string,
    avatarTarget?: string,
    avatarOnClick?: Function,
};

const AvatarAndName = ({ displayName, avatarSrc, avatarHref, avatarTarget = '_blank', avatarOnClick }: Props) => {
    return (
        <AvatarNameView>
            <Avatar src={avatarSrc} target={avatarTarget} href={avatarHref} onClick={avatarOnClick} />
            <p>{displayName}</p>
        </AvatarNameView>
    );
};

export default AvatarAndName;
